import {
  fetchCurrentUserMatchedPFsAsync,
  fetchCurrentUserMatchedPFsAsyncBuilder,
  fetchTechMatchedPFsAsync,
  fetchTechMatchedPFsAsyncBuilder
} from './asyncRequests'
import { IMatchedPF } from '../../types'
import { createSlice } from '@reduxjs/toolkit'
import {IPagingResponse} from "../../types/Requests";

export interface MatchedPFInitialState {
  data: IMatchedPF[]
  loading: boolean
  success: boolean
  error: string
  paging: IPagingResponse
}

const initialState: MatchedPFInitialState = {
  data: [] as IMatchedPF[],
  loading: false,
  success: false,
  error: '',
  paging: {
    totalRows: 0,
    limit: 25,
    skip: 0,
    rows: 0,
    paging: true,
  },
}

export const MatchedPFsSlice = createSlice({
  name: 'matchedPFsSlice',
  initialState,
  reducers: {
    setProgressStatus: (state, action) => {
      const { matchedPFId, progressStatus } = action.payload

      state.data = state.data.map((pf) => {
        if (pf._id === matchedPFId) {
          return { ...pf, progressStatus }
        }

        return pf
      })
    },
  },
  extraReducers: (builder) => {
    fetchTechMatchedPFsAsyncBuilder(builder)
    fetchCurrentUserMatchedPFsAsyncBuilder(builder)
  },
})

export const MatchedPFsActions = {
  ...MatchedPFsSlice.actions,
  fetchTechMatchedPFsAsync,
  fetchCurrentUserMatchedPFsAsync,
}

export const MatchedPFsReducer = MatchedPFsSlice.reducer
